import React from 'react';
import { Form, Select, Typography, InputNumber, Row, Col } from 'antd';

const { Text } = Typography;
const { Option } = Select;

const LoopNodeProperties = ({ config }) => {
  return (
    <>
      <Form.Item label="Loop Type" name="loopType" initialValue={config.loopType || 'for_each'} rules={[{ required: true }]}>
        <Select>
          <Option value="for_each">For Each Row</Option>
          <Option value="batch">Process in Batches</Option>
          <Option value="fixed_count">Repeat Fixed Count</Option>
        </Select>
      </Form.Item>

      <Row gutter={12}>
        <Col span={12}>
          <Form.Item label="Batch Size" name="batchSize" initialValue={config.batchSize || 1}>
            <InputNumber min={1} style={{ width: '100%' }} placeholder="Rows per batch" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Max Iterations" name="maxIterations" initialValue={config.maxIterations || 10000}>
            <InputNumber min={1} style={{ width: '100%' }} placeholder="Safety limit" />
          </Form.Item>
        </Col>
      </Row>

      {config.loopType === 'fixed_count' && (
        <Form.Item label="Repeat Count" name="count" initialValue={config.count || 1}>
          <InputNumber min={1} max={1000} style={{ width: '100%' }} placeholder="Number of times to repeat" />
        </Form.Item>
      )}

      <div style={{ padding: '8px 12px', backgroundColor: '#f9f9f9', borderRadius: '4px', fontSize: '12px', marginTop: '12px' }}>
        <Text type="secondary">
          <strong>Loop Node:</strong><br/>
          • <strong>For Each:</strong> Process each row individually<br/>
          • <strong>Batch:</strong> Group rows into batches for processing<br/>
          • <strong>Fixed Count:</strong> Repeat dataset N times<br/>
          • Useful for row-level transformations
        </Text>
      </div>
    </>
  );
};

export default LoopNodeProperties;